import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string | number;
  icon: BoxIcon;
  iconBgColor: string;
  iconColor: string;
  index: number;
  subtitle?: string;
}
export function StatCard({
  title,
  value,
  icon: Icon,
  iconBgColor,
  iconColor,
  index,
  subtitle
}: StatCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    delay: index * 0.05
  }} className="relative overflow-hidden bg-white rounded-2xl border border-stone-200 p-5 flex flex-col" data-id="element-1013">
      <div className={`w-fit p-2 ${iconBgColor} rounded-lg mb-3`} data-id="element-1014">
        <Icon className={`w-4 h-4 ${iconColor}`} data-id="element-1015" />
      </div>
      <h3 className="text-stone-500 text-sm font-medium" data-id="element-1016">{title}</h3>
      <p className="text-3xl font-bold tracking-tight text-stone-900 mt-1" data-id="element-1017">
        {value}
      </p>
      {subtitle && <p className="text-stone-500 text-xs mt-1" data-id="element-1018">{subtitle}</p>}
    </motion.div>;
}